"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UpdateChildDomain {
    static getAttributeTypeMap() {
        return UpdateChildDomain.attributeTypeMap;
    }
}
UpdateChildDomain.discriminator = undefined;
UpdateChildDomain.attributeTypeMap = [
    {
        "name": "domain",
        "baseName": "domain",
        "type": "string"
    }
];
exports.UpdateChildDomain = UpdateChildDomain;
//# sourceMappingURL=updateChildDomain.js.map